import AuthModal from 'components/AuthModal';
import BlockedEpisodeOverlay from 'components/BlockedEpisodeOverlay';
import ContinueListeningOverlay from 'components/ContinueListeningOverlay';
import ShareModal from 'components/EpisodeShareModal';
import PodcastSearchNavigationModal from 'components/PodcastSearchNavigationModal';
import SponsoredEpisodeModal from 'components/SponsoredEpisodeModal';
import { TldlSearchModal } from 'pages/TldlPage';

export interface ModalsProps {}

const Modals: React.FC<ModalsProps> = () => (
  <>
    <ContinueListeningOverlay />
    <AuthModal />
    <PodcastSearchNavigationModal />
    <BlockedEpisodeOverlay />
    <ShareModal />
    <SponsoredEpisodeModal />
    <TldlSearchModal />
  </>
);

export default Modals;
